/**
 * Created by coolguy on 2017/7/3.
 */
import API from '../util/ApiList';
import Ajax from '../util/ajax.js';
const {
    ajaxCommon
} = Ajax;
const TheApi = API('clue');
const CLUE_LIST = "CLUE_LIST";
const CLUE_ADD = "CLUE_ADD";
const CLUE_DELETE = "CLUE_DELETE";
const CLUE_EDIT = "CLUE_EDIT";
const CLUE_DETAIL = "CLUE_DETAIL"; 

export default {
    CLUE_LIST,
    clueList : (search)=>{
        search && (search.page = search.current || 1);//保持antd的风格
        return ajaxCommon({
            data:search,
            api:TheApi('get')(),
            success: (data)=>({
                type:CLUE_LIST,
                data
            })
        })
    },
    CLUE_ADD,
    clueAdd : (params)=>{
        return ajaxCommon({
            api:TheApi('post')(),
            data:params,
            success:(data)=>({
                type:CLUE_ADD,
                data
            })
        })
    },
    CLUE_DELETE,
    clueDelete:(id)=>{
        return ajaxCommon({
            api:TheApi('delete')(id),
            success:(data)=>({
                type:CLUE_DELETE,
                data,
            })
        })
    },
    CLUE_EDIT,
    clueEdit:(id,info)=>{
        return ajaxCommon({
            api:TheApi('put')(id),
            data:info,
            success:(data)=>({
                type:CLUE_EDIT,
                data,
            })
        })
    },
    CLUE_DETAIL,
    clueDetail:(id)=>{
        return ajaxCommon({
            api:TheApi('get')(id),
            success:(data)=>({
                type:CLUE_DETAIL,
                data,
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/actions/ClueAction.js